export default __webpack_public_path__ + "static/media/Front-desk.1121e321.jpg";